import { useEffect } from "react";
import { useSelector } from "react-redux";

import { Registered } from "@/components/Checkout/TransportService/components/registered";
import { Request } from "@/components/Checkout/TransportService/components/request";
import { useThunkDispatch } from "@/redux/dispatcher";
import * as OrderDetailModule from "@/redux/modules/api/data/orderDetail/orderDetail.module";
import * as OrderDetailSelectors from "@/redux/modules/api/data/orderDetail/orderDetail.selectors";

type Props = {
    className?: string;
};

export const TransportService = ({ className }: Props) => {
    const dispatch = useThunkDispatch();
    const orderDetails = useSelector(OrderDetailSelectors.getOrder);
    const reservationToken = useSelector(
        OrderDetailSelectors.getTransportReservationToken
    );

    useEffect(() => {
        dispatch(OrderDetailModule.load());
    }, [dispatch]);

    if (orderDetails?.reservation) {
        return <Registered className={className} />;
    } else if (orderDetails?.transportPossible && reservationToken) {
        return (
            <Request
                reservationToken={reservationToken}
                className={className}
            />
        );
    } else {
        return null;
    }
};
